import { createRoutine } from 'redux-saga-routines';
import { GET_COMPETITION_DATA } from './constants';

export const getCompetitionDataAction = createRoutine(GET_COMPETITION_DATA);
